// @ts-nocheck
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TextInput } from '@olxbr/ds-web'
import { isValidPassword, rules } from './StrongPasswordInput.data'
import RuleText from './RuleText'
import {
  isSequenceOfKeys,
  isSequenceOfLetters,
  isSequenceOfNumbers,
  createPattern,
} from '../../../util/validators'
import { PASSWORD_MAX_LENGTH } from '../../../util/password'

const StrongPasswordInput = ({
  value,
  maxLength = PASSWORD_MAX_LENGTH,
  label = 'Senha',
  onChange,
  onBlur,
  innerRef,
  customErrorMsg,
  customHasError,
  ...props
}) => {
  const [errorMsg, setErrorMsg] = useState('')
  const [isTouched, setIsTouched] = useState(false)

  const checkPasswordRules = password => {
    const passwordPattern = createPattern(password)
    const rules = [
      {
        message: 'Campo obrigatório. Preencha sua senha.',
        isValid: () => password.length,
      },
      {
        message: 'Não use números em sequência.',
        isValid: () => !isSequenceOfNumbers(passwordPattern),
      },
      {
        message: 'Não use letras em sequência.',
        isValid: () => !isSequenceOfKeys(passwordPattern) && !isSequenceOfLetters(passwordPattern),
      },
      {
        message: 'Esta senha não atende aos requisitos mínimos.',
        isValid: () => isValidPassword(password),
      },
    ]

    for (const rule of rules) {
      if (!rule.isValid()) {
        return rule.message
      }
    }
  }

  const checkIfPasswordIsValid = e => {
    const password = e.target.value
    const errorMsg = checkPasswordRules(password) || ''

    if (errorMsg) {
      setErrorMsg(errorMsg)
    } else {
      setErrorMsg('')
    }
    setIsTouched(true)
  }

  const handleOnChange = e => {
    if (isTouched) {
      checkIfPasswordIsValid(e)
    }
    onChange(e)
  }

  const handleOnBlur = e => {
    if (typeof onBlur === 'function') {
      onBlur(e)
    }
    checkIfPasswordIsValid(e)
  }

  return (
    <div className="flex flex-col" {...props}>
      <TextInput
        id="password-input"
        label={label}
        type="password"
        aria-label="campo de senha"
        value={value}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        state={errorMsg || customHasError ? 'error' : undefined}
        stateMessage={customHasError ? customErrorMsg : errorMsg}
        ref={innerRef}
      />
      <span className="typo-caption mt-2 font-semibold">
        Para sua segurança, crie uma senha com no mínimo:
      </span>
      {Object.keys(rules).map(rule => {
        const ruleStatus = rules[rule].regex.test(value) ? 'valid' : 'invalid'
        return (
          <RuleText key={rule} status={ruleStatus}>
            {rules[rule].text}
          </RuleText>
        )
      })}
    </div>
  )
}

StrongPasswordInput.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  customHasError: PropTypes.bool,
  customErrorMsg: PropTypes.string,
}

const RefStrongPasswordInput = React.forwardRef((props, ref) => (
  <StrongPasswordInput innerRef={ref} {...props} />
))

export default RefStrongPasswordInput
